import { useWatch } from 'react-hook-form';
import { Lead } from 'models/Leads';

const useSearchedLeads = (): string | undefined => {
  const searchedLeads: Lead[] | undefined = useWatch({
    name: 'leads',
  });

  if (!searchedLeads?.length) {
    return undefined;
  }

  const [lead] = searchedLeads;
  return lead?.uid;
};

export default useSearchedLeads;
